<template>
    <div class="Section">
        <PromiseHandler
            ref="handler"
            :doImmediately="doImmediately"
            :minResolvingTime="minResolvingTime"
            #combined="{ status, isResolving, isResolved, isRejected, execute, result, error }"
        >
            <slot v-bind="{ data, isResolving, isResolved, isRejected, execute, error }" />
        </PromiseHandler>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { PromiseHandler, apiPromise } from '../PromiseHandler'

export default {
    name: 'Section',
    components: {
        PromiseHandler,
    },
    props: {
        endpoint: VueTypes.string.isRequired,
        transform: VueTypes.func.def(data => data),
        params: VueTypes.any,
        minResolvingTime: VueTypes.number.def(2000),
        doImmediately: VueTypes.bool.def(true),
        paginated: VueTypes.bool.def(false),
    },
    data () {
        return {
            data: {},
        }
    },
    computed: {
        parameters (page) {
            const {
                endpoint, params, transformData: transform,
            } = this
            return {
                endpoint,
                params: { ...params, page: page || (this.data || {}).current },
                transform,
            }
        },
    },
    mounted () {
        this.execute()
    },
    methods: {
        execute () {
            this.$refs.handler.execute(this.generateRequest(this.parameters))
        },
        generateRequest (params) {
            return apiPromise(params)
        },
        transformData (data) {
            this.data = this.transform(data)
        },
    },
}
</script>

<style lang="scss" scoped>
.Paginate {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 20px;
}
</style>
